module.exports = __webpack_public_path__ + "img/Cloud.323ab96.png";